// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutSharedStyles } from "@tps/App/SharedStyles/CheckoutSharedStyles";
import { cartTotalStyles } from "@tps/Overrides/Widgets/Cart/CartTotal";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

cartTotalStyles.checkoutButton = {
    css: css`
        width: 100%;
        margin-top: 4px;
    `,
};
cartTotalStyles.cancelPunchOutButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 4px;
    `,
};
cartTotalStyles.submitQuoteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 4px;
    `,
};
cartTotalStyles.saveOrderButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};
cartTotalStyles.submitRequisitionButton = {
    css: css`
        width: 100%;
        margin-top: 4px;
    `,
};
cartTotalStyles.orderSummaryWrapper = {
    ...checkoutSharedStyles.orderSummaryWrapper,
};
cartTotalStyles.divider = {
    css: css`
        width: 100%;
        border-top: 1px solid ${color("common.border")};
        &&& {
            margin: 4px 0;
        }
    `,
};
cartTotalStyles.poNumberWrapper = {
    css: css`
        display: flex;
    `,
};
cartTotalStyles.checkIcon = {
    css: css`
        margin-right: 8px;
        margin-top: 4px;
    `,
};
cartTotalStyles.editLink = {
    css: css`
        margin-left: 8px;
        margin-top: 2px;
        align-items: flex-start;
    `,
};

cartTotalStyles.locationLink = {
    css: css`
        margin-left: 20px;
        margin-top: 2px;
        align-items: flex-start;
    `,
};

cartTotalStyles.branchName = {
    css: css`
        font-size: 14px;
        line-height: 22px;
        display: flex;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    `,
};
cartTotalStyles.headingText = {
    variant: "h6",
    forwardAs: "p",
    css: css`
        margin-bottom: 12px;
    `,
};

cartTotalStyles.shippingAddressMessageText = {
    ...fontConfig.xSmall,
};
